import {
  MoonOutlined,
  QuestionCircleOutlined,
  SunOutlined,
} from '@ant-design/icons';
import { SelectLang as UmiSelectLang, useModel } from '@umijs/max';
import { Avatar, Space } from 'antd';
import { createStyles } from 'antd-style';
import React, { useMemo } from 'react';
import { useUserStore } from '@/stores/useUserStore';
import {
  AgentLevelTagWrapper as AgentLevelTag,
  AvatarDropdown,
  AvatarName,
} from './AvatarDropdown';
import DownloadCenter from './DownloadCenter';

export type SiderTheme = 'light' | 'dark';

const AVATAR_COLORS = [
  '#1890ff',
  '#722ed1',
  '#2f54eb',
  '#52c41a',
  '#faad14',
  '#f5222d',
  '#eb2f96',
  '#13c2c2',
];

const useStyles = createStyles(({ token }) => {
  return {
    action: {
      display: 'flex',
      height: '48px',
      alignItems: 'center',
      padding: '0 12px',
      cursor: 'pointer',
      borderRadius: token.borderRadius,
      '&:hover': {
        backgroundColor: token.colorBgTextHover,
      },
    },
    rightHeader: {
      display: 'flex',
      height: '48px',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: '8px',
      padding: '0 16px',
      marginLeft: 'auto',
      borderBottom: `1px solid ${token.colorBorder}`,
      width: '100%',
    },
  };
});

export const ThemeSwitcher: React.FC = () => {
  const { initialState, setInitialState } = useModel('@@initialState');
  const { styles } = useStyles();

  if (!initialState || !initialState.settings) {
    return null;
  }

  const { navTheme } = initialState.settings;

  const toggleTheme = () => {
    setInitialState((s) => ({
      ...s,
      settings: {
        ...s?.settings,
        navTheme: navTheme === 'realDark' ? 'light' : 'realDark',
      },
    }));
  };

  return (
    <div className={styles.action} onClick={toggleTheme}>
      {navTheme === 'realDark' ? (
        <SunOutlined style={{ fontSize: '18px' }} />
      ) : (
        <MoonOutlined style={{ fontSize: '18px' }} />
      )}
    </div>
  );
};

export const SelectLang: React.FC = () => {
  const { styles } = useStyles();
  return (
    <div className={styles.action}>
      <UmiSelectLang />
    </div>
  );
};

export const Question: React.FC = () => {
  const { styles } = useStyles();
  return (
    <div className={styles.action}>
      <a
        href="https://pro.ant.design/docs/getting-started"
        target="_blank"
        rel="noreferrer"
        style={{
          display: 'inline-flex',
          color: 'inherit',
        }}
      >
        <QuestionCircleOutlined style={{ fontSize: '18px' }} />
      </a>
    </div>
  );
};

export const RightHeader: React.FC = () => {
  const { styles } = useStyles();
  const { userInfo: currentUser } = useUserStore();

  const avatarColor = useMemo(() => {
    if (!currentUser?.nickName) return AVATAR_COLORS[0];
    let hash = 0;
    for (let i = 0; i < currentUser.nickName.length; i++) {
      hash = currentUser.nickName.charCodeAt(i) + ((hash << 5) - hash);
    }
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
  }, [currentUser?.nickName]);

  const firstChar = useMemo(() => {
    return currentUser?.nickName?.charAt(0)?.toUpperCase() || '?';
  }, [currentUser?.nickName]);

  return (
    <div className={styles.rightHeader}>
      {/* <Question /> */}
      <DownloadCenter actionClassName={styles.action} />
      <SelectLang />
      <ThemeSwitcher />
      <AvatarDropdown>
        <div className={styles.action}>
          <Space>
            <Avatar
              size="small"
              style={{ backgroundColor: avatarColor, verticalAlign: 'middle' }}
            >
              {firstChar}
            </Avatar>
            <AvatarName />
          </Space>
        </div>
      </AvatarDropdown>
      <AgentLevelTag />
    </div>
  );
};
